import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { findContentById } from '../data/course';

function SidebarToggleIcon({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className={className}>
      <rect x="2" y="2" width="12" height="12" rx="2" />
      <line x1="6" y1="2" x2="6" y2="14" />
    </svg>
  );
}

export default function Header({ sidebarOpen, onToggleSidebar }) {
  const location = useLocation();

  let breadcrumbs = [{ label: 'Group Coaching', to: '/' }];

  const contentMatch = location.pathname.match(/^\/content\/(.+)$/);
  if (contentMatch) {
    const found = findContentById(contentMatch[1]);
    if (found) {
      breadcrumbs.push({ label: `Week ${found.week.number}: ${found.week.title}` });
      breadcrumbs.push({ label: found.content.shortTitle || found.content.title });
    }
  } else if (location.pathname === '/') {
    breadcrumbs.push({ label: 'Overview' });
  } else if (location.pathname === '/community') {
    breadcrumbs.push({ label: 'Community' });
  } else if (location.pathname === '/about') {
    breadcrumbs.push({ label: 'About Dr. Saxena' });
  }

  return (
    <header className="h-12 border-b border-gray-950/[0.06] flex items-center px-4 sm:px-6 bg-white sticky top-0 z-10">
      {!sidebarOpen && (
        <button
          onClick={onToggleSidebar}
          className="p-1.5 rounded-md text-gray-400 hover:text-gray-700 hover:bg-gray-950/[0.04] transition-colors mr-3"
        >
          <SidebarToggleIcon />
        </button>
      )}

      <nav aria-label="Breadcrumb" className="min-w-0 flex-1">
        <ol className="flex items-center gap-x-2 text-sm/6">
          {breadcrumbs.map((crumb, i) => (
            <li key={i} className="flex items-center gap-x-2 min-w-0">
              {i > 0 && <span className="text-gray-950/25 flex-shrink-0">/</span>}
              {crumb.to ? (
                <Link to={crumb.to} className="text-gray-500 hover:text-gray-900 transition truncate">
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-gray-700 truncate">{crumb.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>

      <nav className="flex items-center gap-1 flex-shrink-0">
        <Link
          to="/"
          className={`px-3 py-1 rounded-md text-sm transition ${
            location.pathname === '/' || location.pathname.startsWith('/content')
              ? 'text-gray-900 font-medium'
              : 'text-gray-500 hover:text-gray-900'
          }`}
        >
          Program
        </Link>
        <Link
          to="/community"
          className={`px-3 py-1 rounded-md text-sm transition ${
            location.pathname === '/community'
              ? 'text-gray-900 font-medium'
              : 'text-gray-500 hover:text-gray-900'
          }`}
        >
          Community
        </Link>
        <div className="ml-2 pl-2 border-l border-gray-200">
          <button className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-900 px-2 py-1 rounded-md transition">
            Account
            <svg className="w-3.5 h-3.5" viewBox="0 0 16 16" fill="currentColor">
              <path fillRule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      </nav>
    </header>
  );
}
